import onboardingConstants from '@/v2/domains/Onboarding/constants/constants';

export const JOB_STATUS = {
  WORKING: 'working',
  SUCCESS: 'success',
  ERROR: 'error',
  WARNING: 'warning',
};

export const JOB_TYPES = {
  SYNC_CLASSES: 'import_classes',
};

export const SKIP_SYNC_JOB_NOTIFICATION_PATHS = [
  '/classes/manage',
  onboardingConstants.setupGuideOnboardingUrl,
];
